module.exports = __webpack_public_path__ + "img/icon-check-list.b3af7531.svg";